module.exports = __webpack_public_path__ + "assets/devices/WIRE_KEYPAD-09ffcf289dc89b80ccae3fefa655e556.svg";